import React, { useEffect, useState, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HeroSection } from '../components/HeroSection';
import { ProblemAgitationSection } from '../components/ProblemAgitationSection';
import { ProductRevealSection } from '../components/ProductRevealSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhoIsThisForSection } from '../components/WhoIsThisForSection';
import { ActionPlanSection } from '../components/ActionPlanSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { Link } from 'react-router-dom';
export function SalesPage() {
  const [showFloatingCTA, setShowFloatingCTA] = useState(false);
  useEffect(() => {
    // Add Google Fonts
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Lora:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    document.body.style.backgroundColor = '#0f0f23';
    const handleScroll = () => {
      setShowFloatingCTA(window.scrollY > window.innerHeight * 0.6);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => {
      document.head.removeChild(link);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <main className="min-h-screen w-full bg-[#0f0f23] text-[#f5f0e8] font-sans overflow-x-hidden selection:bg-[#c9a96e] selection:text-[#0f0f23]" data-id="element-241">
      <div className="w-full max-w-3xl mx-auto pb-24" data-id="element-242">
        <HeroSection data-id="element-243" />
        <ProblemAgitationSection data-id="element-244" />
        <ProductRevealSection data-id="element-245" />
        <MechanismSection data-id="element-246" />
        <TestimonialsSection data-id="element-247" />
        <WhoIsThisForSection data-id="element-248" />
        <FAQSection data-id="element-249" />
        <ActionPlanSection data-id="element-250" />

        <footer className="py-12 text-center text-[#d4cfc5] text-sm opacity-60 border-t border-[#b8a9c9]/10 mt-16 px-6" data-id="element-251">
          <div className="max-w-2xl mx-auto space-y-6" data-id="element-252">
            <p className="text-xs leading-relaxed opacity-70" data-id="element-253">
              Disclaimer: This product is for informational purposes only and
              does not constitute medical advice. Always consult your
              pediatrician or healthcare provider about your baby's sleep and
              safety. If you are concerned about your or your baby's health,
              seek professional medical help immediately.
            </p>

            <div className="flex justify-center gap-6 text-[#c9a96e]" data-id="element-254">
              <Link to="/terms" className="hover:text-[#d4b479] transition-colors" data-id="element-255">
                Terms of Service
              </Link>
              <Link to="/privacy" className="hover:text-[#d4b479] transition-colors" data-id="element-256">
                Privacy Policy
              </Link>
            </div>

            <p data-id="element-257">
              © {new Date().getFullYear()} Better By Steps. All rights
              reserved.
            </p>
          </div>
        </footer>
      </div>

      {/* Floating CTA */}
      <AnimatePresence data-id="element-258">
        {showFloatingCTA && <motion.div initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 100,
        opacity: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="fixed bottom-0 left-0 right-0 z-50" data-id="element-259">
            <div className="bg-[#0f0f23]/90 backdrop-blur-md border-t border-[#c9a96e]/20 px-4 py-3 md:py-4" data-id="element-260">
              <div className="max-w-2xl mx-auto flex items-center justify-between gap-4" data-id="element-261">
                <div className="hidden sm:block" data-id="element-262">
                  <p className="text-[#faf6f0] font-serif font-bold text-lg" data-id="element-263">
                    Emergency Night Protocol
                  </p>
                  <p className="text-[#d4cfc5] text-sm" data-id="element-264">
                    Instant digital access
                  </p>
                </div>
                <motion.button whileHover={{
              scale: 1.02,
              backgroundColor: '#d4b479'
            }} whileTap={{
              scale: 0.98
            }} onClick={() => {
              document.getElementById('pricing')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} className="w-full sm:w-auto px-6 py-3 bg-[#c9a96e] text-[#0f0f23] font-bold rounded-lg shadow-lg shadow-[#c9a96e]/20 text-base md:text-lg flex items-center justify-center gap-2" data-id="element-265">
                  <span data-id="element-266">Get It Now</span>
                  <span className="bg-[#0f0f23]/15 px-2.5 py-0.5 rounded-md text-[#0f0f23] font-extrabold" data-id="element-267">
                    $6.36
                  </span>
                </motion.button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </main>;
}